import { render, staticRenderFns } from "./FormCustomerNew.vue?vue&type=template&id=34b77bac&scoped=true"
import script from "./FormCustomerNew.vue?vue&type=script&lang=js"
export * from "./FormCustomerNew.vue?vue&type=script&lang=js"
import style0 from "./FormCustomerNew.vue?vue&type=style&index=0&id=34b77bac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34b77bac",
  null
  
)

export default component.exports